const DIMENSIONS = {
  MAIN_PAGE: {
    SEARCH_AND_SCROLLER_BOX_HEIGHT: 60,
  },
  APP_BAR: {
    HEIGHT: 60,
    BOTTOM_SPACING: 20,
  },
  BAG_BAR: {
    HEIGHT: 60,
  },
};

export default DIMENSIONS;
